import { FormInstance } from 'antd';

import {
	BUSINESS_OVERVIEW_FIELD_NAMES_MAP,
	FORM_FIELD_NAMES_MAP,
} from '@/constants/formFieldNames';

import { EFundingPurposeType } from '@/types/formFieldTypes';

import { TBankStatementsData, TDebtScheduleData } from '../types';

const { businessOverview } = FORM_FIELD_NAMES_MAP;
const { name, dbaName } = BUSINESS_OVERVIEW_FIELD_NAMES_MAP;

export const generateFlowsData = (
	form: FormInstance,
	fundingPurpose: EFundingPurposeType,
	applicationId: string,
): { bankStatements: TBankStatementsData | null; debtSchedule: TDebtScheduleData | null } => {
	let bankStatements = null;
	let debtSchedule = null;

	if (fundingPurpose !== EFundingPurposeType.BusinessAcquisition) {
		bankStatements = { applicationId };
	}

	if (
		![
			EFundingPurposeType.StartBusiness,
			EFundingPurposeType.BusinessAcquisition,
			EFundingPurposeType.BuyBusiness,
		].includes(fundingPurpose)
	) {
		const businessName = form.getFieldValue([businessOverview, name]);
		const dbaNameValue = form.getFieldValue([businessOverview, dbaName]);

		debtSchedule = {
			applicationId,
			metadata: encodeBusinessMetadata(businessName, dbaNameValue),
		};
	}

	return { bankStatements, debtSchedule };
};

const encodeBusinessMetadata = (businessName: string, doingBusinessAs: string): string => {
	// Combine the values with '||' delimiter
	const combinedData = `${businessName}||${doingBusinessAs}`;

	return btoa(combinedData);
};
